import { render, staticRenderFns } from "./DialogDownload.vue?vue&type=template&id=e8f4238a&scoped=true&"
import script from "./DialogDownload.vue?vue&type=script&lang=js&"
export * from "./DialogDownload.vue?vue&type=script&lang=js&"
import style0 from "./DialogDownload.vue?vue&type=style&index=0&id=e8f4238a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f4238a",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QIcon,QImg});qInstall(component, 'directives', {ClosePopup});
